import RootLayout from '../../layouts/RootLayout';
import { useAuth } from '../../../lib/auth';
import { cn } from '../../../lib/helpers.ts';
import HeadLogo from '../../../components/logos/HeadLogo.tsx';
import {
    UilFileSlash,
    UilLockOpenAlt,
    UilUniversity,
    UilUsersAlt,
} from '@iconscout/react-unicons';
import {
    FeatureListItem,
    FeatureListQuote,
} from '../../../components/lists/FeatureList.tsx';
import SignUpForm from '../../containers/SignUpForm.tsx';

export default function SignUpPageB() {
    useAuth({
        middleware: 'guest',
        redirectTo: '/dashboard',
        tmp: 'SignUpPageB',
    });

    return (
        <RootLayout>
            <main className="container mx-auto flex h-screen flex-col items-center justify-start px-4 py-32">
                <HeadLogo />
                <h1>Registrace</h1>
                <p className={cn('mb-6 text-ink-800', 'text-center')}>
                    Vyzkoušejte demo verzi Všímavce bez nutnosti nákupu roční
                    licence.
                </p>
                <div
                    className={cn(
                        'mt-12 grid w-full gap-12 pb-32',
                        'max-w-3xl grid-cols-1 xl:max-w-none xl:grid-cols-2'
                    )}
                >
                    <div className="rounded-3xl border p-8 shadow-sm">
                        <SignUpForm />
                    </div>
                    <div
                        className={cn(
                            'flex flex-col space-y-4',
                            'rounded-3xl p-8',
                            'self-start'
                        )}
                    >
                        <h2 className="mb-0 block text-2xl font-bold">
                            Co na vás čeká?
                        </h2>

                        <ul className="space-y-6">
                            <FeatureListItem
                                icon={UilLockOpenAlt}
                                title={<>DEMO verze zdarma &ndash; navždy</>}
                            />
                            <FeatureListItem
                                icon={UilUsersAlt}
                                title="Neomezený počet uživatelů"
                            />
                            <FeatureListItem
                                icon={UilFileSlash}
                                title="Bez závazků a zadávání platební karty"
                            />
                            <FeatureListItem
                                icon={UilUniversity}
                                title={
                                    <>
                                        Přidejte se k více než 600&nbsp;školám,
                                        které už Všímavce vyzkoušely
                                    </>
                                }
                            />
                        </ul>

                        <h2 className="mb-0 block pt-12 text-2xl font-bold">
                            Jaké jsou zkušenosti učitelů?
                        </h2>
                        <ul className="space-y-6">
                            <FeatureListQuote
                                // icon={UilBoltAlt}
                                author="Učitelka, ZŠ Hošťka"
                                title="Okamžitá integrace"
                                description={
                                    <>
                                        &bdquo;Překvapila nás časová
                                        nenáročnost, jednoduchost
                                        a&nbsp;okamžitá použitelnost aplikace
                                        i&nbsp;bez nutné návaznosti
                                        a&nbsp;studování mnohdy obsáhlých
                                        metodik.&ldquo;
                                    </>
                                }
                            />
                            <FeatureListQuote
                                // icon={UilSmileBeam}
                                author="Učitelka, ZŠ a MŠ Sluníčko"
                                title="Klidná třída"
                                description={
                                    <>
                                        &bdquo;Po pravidelném zapojování kocoura
                                        Všímavce do výuky nám přijdou děti
                                        klidnější a&nbsp;je znát, když se
                                        nějakou dobu nepoužívá.&ldquo;
                                    </>
                                }
                                isLeft={false}
                            />
                        </ul>
                    </div>
                </div>
            </main>
        </RootLayout>
    );
}
